<template>
  <div id="Uploadslides">
    <sidbar-admin
      :setready="s"
      :setmyjob="myjobs"
      :setpacking="packing"
      :orders="newjobs"
    />

    <form @submit.prevent="createJob" enctype="multipart/form-data">
      <div class="container mt-10">
        <div class="space"></div>
        <div class="card-columns">
          <div class="card card-order-list card-margin border-light shadow">
            <div
              class="card-body card-content"
              v-if="companyLogo.length < 0 || companyLogo.length == ''"
            >
              <!-- <h5 class="card-title">ออร์เดอร์ที่</h5> -->
              <div class="card-text">
                <input
                  type="file"
                  @change="onFileSelected"
                  accept="image/*"
                  class="input-file"
                  name="photo-upload-button"
                  id="photo-upload-button"
                />
                <label for="photo-upload-button"
                  ><i class="fas fa-cloud-upload-alt fa-4x"></i
                ></label>
              </div>
            </div>

            <div class="image-preview" v-if="companyLogo.length > 0">
              <img :src="companyLogo" class="uploading-image" />
            </div>

            <button
              v-if="companyLogo.length > 0"
              class="btn btn-success btn-floating"
              type="submit"
            >
              Upload
            </button>
            <button
              v-if="companyLogo.length > 0"
              class="btn btn-secondary btn-floating-02"
              @click="cancle()"
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </form>
    <div class="container">
      <br />
      <table class="table table-striped">
        <thead>
          <tr>
            <th scope="col">ลำดับ</th>
            <th scope="col">id</th>
            <th scope="col">แสดงรูป</th>
            <th scope="col">ลำดับการแสดง</th>
            <th scope="col">สถานะ</th>
            <th scope="col">จัดการข้อมูล</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in slides" :key="index">
            <th scope="row">{{ index + 1 }}</th>
            <th>{{ item.info_id }}</th>
            <td><img :src="item.info_img" alt="" class="img-slides" /></td>
            <td>
              {{ item.sort }}
            </td>
            <td>
              <div class="panel panel-default">
                <div class="panel-heading"></div>
                <div class="panel-body">
                
                  <!--Only code you need is this label-->

                  <!-- <label class="switch" v-if="item.isshow ===1">
                    <input type="checkbox" @click="toggleCheckbox(item.info_id)"  checked/>
                    <div class="slider round"></div>
                  </label>
                  <p>{{ checkbox }}</p> -->
                  <!-- <b-form-checkbox v-model="checked" name="check-button" switch>
                    Switch Checkbox <b>(Checked: {{ checked }})</b>
                  </b-form-checkbox> -->
                </div>
              </div>
              <!-- <p v-if="item.isshow !== 1">ไม่แสดง</p> -->
            </td>
            <td>
              <button class="btn btn-info" @click="setslide_info(item.info_id)">
                set
              </button>
             
              <button
                type="button"
                class="btn btn-danger"
                data-toggle="modal"
                :data-target="'#' + item.info_id"
              >
                แก้ไขข้อมูล
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import SidbarAdmin from "./sidbar-admin.vue";
export default {
  components: { SidbarAdmin },

  name: "Uploadslides",
  data() {
    return {
      //   title: "",
      companyLogo: "",
      token: "dQpojB8WkH7HAZdh223jaqFSB1x5RYoKBjU0BAaVZt8DTVaxO5Sx5DlsErA2Zsu",
      ready: [],
      readMore: {},
      isLoading: false,
      show: false,
      orderMore: {},
      s: "",
      newjobs: [],
      myjobs: [],
      packing: [],
      code: "",
      slides: [],
      checkbox: false,
      checked: false,
      selected: [],
      currentState: false,
    };
  },
  methods: {
    toggleCheckbox() {
      // console.log(id);
      this.checkbox = !this.checkbox;
      this.$emit("setCheckboxVal", this.checkbox);
    },
    onFileSelected(e) {
      let image = e.target.files[0];
      let reader = new FileReader();
      reader.readAsDataURL(image);
      reader.onload = (e) => {
        this.companyLogo = e.target.result;
      };
    },

    createJob() {
      let data = {
        token: this.token,
        file_name_base64: this.companyLogo,
      };
      const headers = {
        "content-type": "application/json",
      };

      axios
        .post(
          "https://smartlibrary.ubru.ac.th/api/booking/upload_info_web",
          data,
          { headers }
        )
        .then((res) => {
          if (res.data.msg.status !== 500) {
            alert(res.data.msg.message);
            this.companyLogo = "";
          } else {
            alert(res.data.msg.message);
          }
        });
    },
    getready() {
      let data = {
        token: this.token,
        staff_code: this.code,
      };
      const headers = {
        "content-type": "application/json",
      };

      axios
        .post("https://smartlibrary.ubru.ac.th/api/booking/get_ready", data, {
          headers,
        })
        .then((res) => {
          this.ready = res.data.Orders;
          this.s = this.ready.length;
          this.packing = res.data.dasboard[0].packing;
          this.newjobs = res.data.dasboard[0].neworders;
          this.myjobs = res.data.dasboard[0].myjob;
        });
    },
    cancle() {
      this.companyLogo = "";
    },
    getslide_info() {
      // console.log("get_slide");
      let data = {
        token: this.token,
      };
      const headers = {
        "content-type": "application/json",
      };
      axios
        .post(
          "https://smartlibrary.ubru.ac.th/api/booking/get_info_web_all",
          data,
          headers
        )
        .then((res) => {
          console.log("res= ", res.data.info_web);
          this.slides = res.data.info_web;
          // this.options = res.data.info_web;
          // console.log(this.slides.isshow);
        });
    },
    setslide_info(id) {
      // console.log(id);
      let data = {
        token: this.token,
        info_id: id,
        isshow: 0,
      };
      // console.log(data);
      const headers = {
        "content-type": "application/json",
      };
      axios
        .post(
          "https://smartlibrary.ubru.ac.th/api/booking/set_info_web",
          data,
          headers
        )
        .then((res) => {
          this.slides = res.data.info_web;

          // console.log(this.slides.isshow);
        });
      // set_info_web
      // info_id: int  sort:int (จัดเรียงลำดับภาพ)
      // isshow : int (0=ไม่โชว์,1 = show)
    },
  },
  mounted() {
    if (localStorage.getItem("auth") != null) {
      let c = JSON.parse(localStorage.getItem("auth"));
      this.code = c.std_code;
    }

    this.getready();
    this.getslide_info();
  },
};
</script>

<style scoped>
.switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 34px;
}

.switch input {
  display: none;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 26px;
  width: 26px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

input:checked + .slider {
  background-color: #101010;
}

input:focus + .slider {
  box-shadow: 0 0 1px #101010;
}

input:checked + .slider:before {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(26px);
}

.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}
.img-slides {
  width: auto;
  height: 100px;
}
.space {
  height: 80px;
}
.image-preview {
  position: relative;
  display: flex;
  flex-direction: column;
  min-width: 0;
  word-wrap: break-word;
  background-color: #fff;
  background-clip: border-box;
  background: -webkit-linear-gradient(-55deg, #754bd4 40%, #2ba3be 100%)
    no-repeat center center;
  /* border: 1px solid rgba(0, 0, 0, 0.125); */
  margin-top: 0 auto;
  border-radius: 0.25rem;
}
.uploading-image {
  border-radius: 10px;
}
.card-content {
  position: relative;
}
.card-order-list {
  padding: 5px;
  border-radius: 15px;
  background: -webkit-linear-gradient(-55deg, #754bd4 40%, #2ba3be 100%)
    no-repeat center center;
}

.btn-floating {
  position: absolute;
  /* width: 46px;
  height: 40px;
  background: rgb(120, 90, 227);
  color: #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  font-size: 12px; */
  top: -40px;
  right: 90px;
  /* top: -100px; */
  font-size: 14px;
  color: rgb(255, 255, 255);
}
.btn-floating-02 {
  position: absolute;
  /* width: 46px;
  height: 40px;
  background: rgb(120, 90, 227);
  color: #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  font-size: 12px; */
  top: -40px;
  right: 10px;
  /* top: -100px; */
  font-size: 14px;
  color: rgb(255, 255, 255);
}
@media (min-width: 768px) {
  .card-columns {
    column-count: 1;
  }
}

/* Large devices (desktops, 992px and up) */
@media (min-width: 992px) {
  .card-columns {
    column-count: 1;
  }
}

/* Extra large devices (large desktops, 1200px and up) */
@media (min-width: 1200px) {
  .card-columns {
    column-count: 1;
  }
}

form:hover,
form:focus {
  border-color: #0070d3;
  cursor: pointer;
  color: #9ff1c8;
}

.card-text {
  height: auto;
  margin: 20px 0px;
  position: relative;
  text-align: center;
  width: 100%;
  color: #ffffff;
}
.input-file {
  height: 0.1px;
  opacity: 0;
  overflow: hidden;
  position: absolute;
  width: 0.1px;
  z-index: -1;
}
:focus + label + i {
  border-color: #0070d3;
}

.mt-10 {
  margin-top: 5rem;
}
</style>
